import { render, staticRenderFns } from "./MarkerClusterer.vue?vue&type=template&id=472461b2&"
import script from "./MarkerClusterer.vue?vue&type=script&lang=js&"
export * from "./MarkerClusterer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports